export default __webpack_public_path__ + "static/media/studentboard.fdbf1fe2.png";